export default __webpack_public_path__ + "static/media/report-analytics-analytics.ba1a9b28.png";